<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.username"
        placeholder="请输入用户名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.last_name"
        placeholder="请输入姓"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.first_name"
        placeholder="请输入名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.user_id"
        placeholder="请输入用户ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.uuid"
        placeholder="请输入用户UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.email"
        placeholder="请输入邮箱"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_active"
        placeholder="是否有效VIP"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="是" value="1" />
        <el-option label="否" value="0" />
      </el-select>
      <el-select
        v-model="listQuery.vip_level_no"
        placeholder="VIP 等级"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option
          :label="item.name"
          :value="item.level_no"
          v-for="(item, index) in viplist"
          :key="index"
        />
      </el-select>
      <el-select
        v-model="listQuery.revenue_type"
        placeholder="分红类型"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="零售奖励" value="retail_bonus" />
        <el-option label="分享奖励" value="referral_bonus" />
        <el-option label="建设奖励" value="distribution_bonus" />
        <el-option label="成长奖励" value="expansion_bonus" />
        <el-option label="扩展补充奖励" value="expansion_extra_bonus" />
        <el-option label="安心奖励" value="welfare_bonus" />
        <el-option label="创始人分红" value="founder_bonus" />
        <el-option label="VIP 分红" value="vip_bonus" />
        <el-option label="钻石分红" value="super_vip_bonus" />
      </el-select>

      <span class="px-10">最新奖励时间</span>
      <el-date-picker
        class="filter-item"
        v-model="listQuery.date"
        type="daterange"
        @change="changedata"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <download-excel
        class="filter-item"
        :fields="json_fields"
        :fetch="handleExport"
        type="xls"
        name="数据统计.xls"
        worksheet="数据统计"
      >
        <el-button type="success" :loading="exportLoading">
          导出数据统计
        </el-button>
      </download-excel>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="用户id" width="120">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name || '-' }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="手机号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.log_no }}
        </template>
      </el-table-column> -->
      <el-table-column label="邮箱" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>
      <el-table-column label="推荐人ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.parent_uuid ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="加入时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="成为VIP时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_first_buy_at ?? '-' }}
        </template>
      </el-table-column> -->
      <el-table-column label="是否有效VIP" min-width="110" align="center">
        <template slot-scope="scope">
          {{ vip_status(scope.row.vip_status) }}
        </template>
      </el-table-column>
      <el-table-column label="VIP等级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_level_name || '无等级' }}
        </template>
      </el-table-column>
      <el-table-column label="总订单数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_num }}
        </template>
      </el-table-column>
      <el-table-column label="分红类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ revenue_type(scope.row.revenue_type) }}
        </template>
      </el-table-column>
      <el-table-column label="累计奖励金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_reward_value }}
        </template>
      </el-table-column>
      <el-table-column label="累计奖励RP积分" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_reward_rp }}
        </template>
      </el-table-column>
      <el-table-column label="最近活跃时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_login_at }}
        </template>
      </el-table-column>
      <el-table-column label="最新奖励时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_reward_at }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal === 1" type="success">
            正常
          </el-tag>
          <el-tag v-else-if="scope.row.check_status === 0" type="warning"
            >冻结</el-tag
          >
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="edit(scope.row)">
            详情
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
export default {
  components: { downloadExcel },
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        email: '',
        vip_level_no: '',
        revenue_type: '',
        start_at: '',
        end_at: '',
        is_active: '',
      },
      viplist: [],
      json_fields: {
        用户id: {
          field: 'user_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        姓: {
          field: 'last_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        名: {
          field: 'first_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        // 手机号: {
        //   field: 'num',
        //   //自定义回调函数
        //   callback: (value) => {
        //     return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
        //   },
        // },
        邮箱: {
          field: 'email',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        推荐人ID: {
          field: 'parent_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        加入时间: {
          field: 'created_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        成为VIP时间: {
          field: 'vip_first_buy_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        是否有效VIP: {
          field: 'vip_status',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              this.vip_status(value) +
              '</p>'
            )
          },
        },
        总订单数: {
          field: 'order_num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        分红类型: {
          field: 'revenue_type',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              this.revenue_type(value) +
              '</p>'
            )
          },
        },
        累计奖励金额: {
          field: 'total_reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        累计奖励RP积分: {
          field: 'total_reward_rp',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        最近活跃时间: {
          field: 'last_login_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        最新奖励时间: {
          field: 'last_reward_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        状态: {
          field: 'is_normal',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value == 1
              ? '正常'
              : '冻结' + '</p>'
          },
        },
      },
    }
  },
  created() {
    this.vipLevelConfigs()
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  computed: {
    vip_status() {
      return (val) => {
        switch (val) {
          case 'active':
            return 'VIP 已激活'
          case 'inactive':
            return 'VIP 未激活'
          case 'inactive_affiliate':
            return 'VIP 未激活-网红'
          case 'never_purchased':
            return '非VIP'
        }
      }
    },
    revenue_type() {
      return (val) => {
        switch (val) {
          case 'retail_bonus':
            return '零售奖励'
          case 'referral_bonus':
            return '分享奖励'
          case 'distribution_bonus':
            return '建设奖励'
          case 'expansion_bonus':
            return '成长奖励'
          case 'expansion_extra_bonus':
            return '扩展补充奖励'
          case 'welfare_bonus':
            return '安心奖励'
          case 'founder_bonus':
            return '创始人分红'
          case 'vip_bonus':
            return 'VIP 分红'
          case 'super_vip_bonus':
            return '钻石分红'
        }
      }
    },
  },
  methods: {
    vipLevelConfigs() {
      request({
        url: '/api/backend/dataCount/vipLevelConfigs',
        method: 'get',
        params: this.listQuery,
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.viplist = res.data
        }
      })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    handleExport() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/dataCount/userDataCountList',
        method: 'get',
        params: listQuery,
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/dataCount/userDataCountList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
